// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/define-category/app/css/app.css
// module id = 785
// module chunks = 0